import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import uuid from 'uuid/v1';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useFormState } from 'modules/taboola-common-frontend-modules/forms';
import { useMultiLayerPathParams } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerPathParams';
import { usePushReportApi } from 'services/api/pushReportApi';
import { PUSH_API_ROUTE } from '../config';
import { updateSubscription } from '../flows/updateSubscription';

export const usePushApiEditorState = () => {
    const { getPushReport } = usePushReportApi();
    const { subscriptionId } = useMultiLayerPathParams();
    const { formAccount } = useFormDataContext();
    const dispatch = useDispatch();

    const formDataFetcher = useCallback(async () => {
        const subscription = await getPushReport(formAccount.accountId, subscriptionId);

        subscription.entities = subscription.entities.map(entity => ({
            ...entity,
            fields: entity.fields.map(field => ({
                ...field,
                id: uuid(),
                filters: field.filters.map(filter => ({
                    ...filter,
                    id: uuid(),
                })),
            })),
        }));

        return subscription;
    }, [formAccount, getPushReport, subscriptionId]);

    const { submit } = useFormState({ formDataFetcher, waitAccountFetched: false });

    const handleEditPushApiSubmitWrapper = useCallback(() => {
        const updatePushApiWrapper = subscription => {
            return dispatch(updateSubscription({ accountId: formAccount.accountId, subscription }));
        };
        return submit({
            saveFormData: updatePushApiWrapper,
            successUrl: PUSH_API_ROUTE,
        });
    }, [submit, formAccount.accountId, dispatch]);

    return { submit: handleEditPushApiSubmitWrapper };
};
